const DEFAULT_LOCALE = "ko-KR";

const IMAGE_FUSION_LABELS = {
  ko: {
    0: "\uC815\uC0C1",
    1: "\uC694\uC8FC\uC758",
    2: "\uC774\uC0C1",
    3: "\uC7AC\uC810\uAC80 \uC694\uB9DD",
  },
  en: {
    0: "Normal",
    1: "Caution",
    2: "Abnormal",
    3: "Reinspection Required",
  },
  ja: {
    0: "\u6B63\u5E38",
    1: "\u6CE8\u610F",
    2: "\u7570\u5E38",
    3: "\u518D\u70B9\u691C\u5FC5\u8981",
  },
  zh: {
    0: "\u6B63\u5E38",
    1: "\u6CE8\u610F",
    2: "\u5F02\u5E38",
    3: "\u9700\u91CD\u65B0\u68C0\u67E5",
  },
  vi: {
    0: "Binh thuong",
    1: "Can chu y",
    2: "Bat thuong",
    3: "Yeu cau kiem tra lai",
  },
};

const VIDEO_FUSION_LABELS = {
  ko: {
    0: "\uC815\uC0C1",
    1: "\uACBD\uACE0",
    2: "\uC774\uC0C1",
    3: "\uC7AC\uC810\uAC80 \uC694\uB9DD",
  },
  en: {
    0: "Normal",
    1: "Warning",
    2: "Abnormal",
    3: "Reinspection Required",
  },
  ja: {
    0: "\u6B63\u5E38",
    1: "\u8B66\u544A",
    2: "\u7570\u5E38",
    3: "\u518D\u70B9\u691C\u5FC5\u8981",
  },
  zh: {
    0: "\u6B63\u5E38",
    1: "\u8B66\u544A",
    2: "\u5F02\u5E38",
    3: "\u9700\u91CD\u65B0\u68C0\u67E5",
  },
  vi: {
    0: "Binh thuong",
    1: "Canh bao",
    2: "Bat thuong",
    3: "Yeu cau kiem tra lai",
  },
};

const FUSION_RESULT_CODE_BY_LABEL = {
  "\uC815\uC0C1": 0,
  Normal: 0,
  "\u6B63\u5E38": 0,
  "Binh thuong": 0,
  "B\u00ECnh th\u01B0\u1EDDng": 0,
  "\uACBD\uACE0": 1,
  "\uC694\uC8FC\uC758": 1,
  "\uC8FC\uC758": 1,
  Caution: 1,
  Warning: 1,
  "\u8B66\u544A": 1,
  "\u6CE8\u610F": 1,
  "Can chu y": 1,
  "Canh bao": 1,
  "C\u1EA7n ch\u00FA \u00FD": 1,
  "C\u1EA3nh b\u00E1o": 1,
  "\uC774\uC0C1": 2,
  Abnormal: 2,
  Fault: 2,
  "\u7570\u5E38": 2,
  "\u5F02\u5E38": 2,
  "Bat thuong": 2,
  "B\u1EA5t th\u01B0\u1EDDng": 2,
  "\uC7AC\uC810\uAC80 \uC694\uB9DD": 3,
  "Reinspection Required": 3,
  "Recheck Required": 3,
  "\u518D\u70B9\u691C\u5FC5\u8981": 3,
  "\u9700\u91CD\u65B0\u68C0\u67E5": 3,
  "Yeu cau kiem tra lai": 3,
  "Y\u00EAu c\u1EA7u ki\u1EC3m tra l\u1EA1i": 3,
};

function resolveLocale(i18nOrLocale = DEFAULT_LOCALE) {
  const locale =
    typeof i18nOrLocale === "string"
      ? i18nOrLocale
      : i18nOrLocale?.resolvedLanguage ||
        i18nOrLocale?.language ||
        DEFAULT_LOCALE;

  const normalized = String(locale || DEFAULT_LOCALE).toLowerCase();

  if (normalized.startsWith("en")) return "en";
  if (normalized.startsWith("ja")) return "ja";
  if (normalized.startsWith("zh")) return "zh";
  if (normalized.startsWith("vi")) return "vi";
  return "ko";
}

export function normalizeFusionResultCode(value, fallback = null) {
  if (value === null || value === undefined || value === "") return fallback;

  const numericValue = Number(value);
  if (Number.isFinite(numericValue) && [0, 1, 2, 3].includes(numericValue)) {
    return numericValue;
  }

  const normalizedLabel = String(value).trim();
  if (
    Object.prototype.hasOwnProperty.call(
      FUSION_RESULT_CODE_BY_LABEL,
      normalizedLabel,
    )
  ) {
    return FUSION_RESULT_CODE_BY_LABEL[normalizedLabel];
  }

  return fallback;
}

export function getFusionResultTone(value) {
  const code = normalizeFusionResultCode(value);

  if (code === 0) return "normal";
  if (code === 1) return "warning";
  if (code === 2) return "abnormal";
  if (code === 3) return "recheck";
  return null;
}

export function getImageFusionLabelsByLocale(i18nOrLocale) {
  return IMAGE_FUSION_LABELS[resolveLocale(i18nOrLocale)];
}

export function getVideoFusionLabelsByLocale(i18nOrLocale) {
  return VIDEO_FUSION_LABELS[resolveLocale(i18nOrLocale)];
}

export function getFusionResultLabel(
  value,
  i18nOrLocale,
  { variant = "image", fallback = "" } = {},
) {
  const code = normalizeFusionResultCode(value);
  if (code === null) return fallback;

  const labels =
    variant === "video"
      ? getVideoFusionLabelsByLocale(i18nOrLocale)
      : getImageFusionLabelsByLocale(i18nOrLocale);

  return labels?.[code] ?? fallback;
}
